<template>
    <div>

        <c-panel v-if="editAluno && !dados.id">
            <div class="loading-form" style="min-height: 270px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-form @submit.native.prevent="onSubmitAluno" style="min-height: 270px;" v-if="!editAluno || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editAluno || dados.id">

                <c-panel title="DADOS GERAIS" titleIcon='fas fa-user'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Nome do Aluno *" prop="nome" :rules="[$requiredBlur]" key="nome">
                                <el-input v-model="dados.nome" maxlength="191" v-on:blur="checkIfAlunoExist()" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Data de Nascimento *" prop="data_nascimento" :rules="[$requiredBlur, $dataBlur]" key="data_nascimento">
                                <el-input v-model="dados.data_nascimento" maxlength="191" v-mask="'##/##/####'" v-on:blur="checkIfAlunoExist()" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Nome do Aluno no Educacenso" prop="nome_aluno_censo" key="nome_aluno_censo">
                                <el-input v-model="dados.nome_aluno_censo" maxlength="191" v-on:blur="formatData('nome_aluno_censo')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="INEP (12 dígitos)" prop="inep" key="inep">
                                <el-input v-model="dados.inep" maxlength="191" v-mask="'############'" v-on:blur="formatData('inep', 12)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Raça/Cor *" prop="cor" :rules="[$requiredChange]" key="cor">
                                <el-select v-model="dados.cor" clearable>
                                    <el-option :key="0" label="NÃO DECLARADA" :value="0"></el-option>
                                    <el-option :key="1" label="BRANCA" :value="1"></el-option>
                                    <el-option :key="2" label="PRETA" :value="2"></el-option>
                                    <el-option :key="3" label="PARDA" :value="3"></el-option>
                                    <el-option :key="4" label="AMARELA" :value="4"></el-option>
                                    <el-option :key="5" label="INDÍGENA" :value="5"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Sexo *" prop="sexo" :rules="[$requiredChange]" key="sexo">
                                <el-select v-model="dados.sexo" clearable>
                                    <el-option :key="0" label="MASCULINO" :value="0"></el-option>
                                    <el-option :key="1" label="FEMININO" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Mãe *" prop="mae" :rules="[$requiredBlur]" key="mae">
                                <el-input v-model="dados.mae" maxlength="191" v-on:blur="formatData('mae')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Pai" prop="pai" key="pai">
                                <el-input v-model="dados.pai" maxlength="191" v-on:blur="formatData('pai')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Responsável" prop="responsavel" key="responsavel">
                                <el-input v-model="dados.responsavel" maxlength="191" v-on:blur="formatData('responsavel')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Parentesco" prop="parentesco" key="parentesco">
                                <el-select v-model="dados.parentesco" clearable>
                                    <el-option key="NÃO DECLARADA" label="NÃO DECLARADA" value="NÃO DECLARADA"></el-option>
                                    <el-option key="PAI" label="PAI" value="PAI"></el-option>
                                    <el-option key="MAE" label="MAE" value="MAE"></el-option>
                                    <el-option key="AVÔ(Ó)" label="AVÔ(Ó)" value="AVÔ(Ó)"></el-option>
                                    <el-option key="TIO(A)" label="TIO(A)" value="TIO(A)"></el-option>
                                    <el-option key="IRMÃO(Ã)" label="IRMÃO(Ã)" value="IRMÃO(Ã)"></el-option>
                                    <el-option key="PRIMO(A)" label="PRIMO(A)" value="PRIMO(A)"></el-option>
                                    <el-option key="PADASTRO" label="PADASTRO" value="PADASTRO"></el-option>
                                    <el-option key="MADRASTA" label="MADRASTA" value="MADRASTA"></el-option>
                                    <el-option key="OUTRO" label="OUTRO" value="OUTRO"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Telefone" prop="telefone" key="telefone">
                                <el-input v-model="dados.telefone" maxlength="191" v-mask="'(##) ########'" v-on:blur="formatData('telefone', 13)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Celular" prop="celular" key="celular">
                                <el-input v-model="dados.celular" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular', 14)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Outro Celular" prop="celular_outro" key="celular_outro">
                                <el-input v-model="dados.celular_outro" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular_outro', 14)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="(dados.nacionalidade == 3) ? 12 : 24" :md="(dados.nacionalidade == 3) ? 12 : 24">
                            <el-form-item label="Nacionalidade *" prop="nacionalidade" :rules="[$requiredChange]" key="nacionalidade">
                                <el-select @change="changeNacionalidade()" v-model="dados.nacionalidade" clearable>
                                    <el-option :key="1" label="BRASILEIRA" :value="1"></el-option>
                                    <el-option :key="2" label="BRASILEIRA - NASCIDO NO EXTERIOR OU NATURALIZADO" :value="2"></el-option>
                                    <el-option :key="3" label="ESTRANGEIRA" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="dados.nacionalidade == 3" :xs="24" :sm="12" :md="12">
                            <el-form-item label="País de Nacionalidade" prop="pais_id" :rules="[$requiredChange]" key="pais_id">
                                <el-select v-model="dados.pais_id" clearable>
                                    <el-option v-for="(pais, i) in paises" :key="i" :label="pais.nome" :value="pais.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="dados.nacionalidade == 1">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Município de Nascimento" prop="municipio_nascimento.nome" :rules="[$requiredChange]" key="municipio_nascimento">
                                <el-input style="width: calc(100% - 55px); float: left" readonly v-model="dados.municipio_nascimento.nome" maxlength="191" class="readonly" clearable></el-input>
                                <el-button style="float: right; width: 35px; height: 35px;" @click="showSearchMunNascimento" icon="el-icon-search" circle></el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="DOCUMENTAÇÃO" titleIcon='fas fa-portrait'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="NIS (do aluno)" prop="nis" key="nis">
                                <el-input v-model="dados.nis" maxlength="191" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="CPF (do aluno)" prop="cpf" key="cpf">
                                <el-input v-model="dados.cpf" maxlength="191" v-mask="'###.###.###-##'" v-on:blur="formatData('cpf', 14)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Cartão do SUS (do aluno)" prop="cartao_sus" key="cartao_sus">
                                <el-input v-model="dados.cartao_sus" maxlength="191" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="RG (do aluno)" prop="rg" key="rg">
                                <el-input v-model="dados.rg" maxlength="191" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Data de Emissão" prop="data_emissao_rg" key="data_emissao_rg">
                                <el-input v-model="dados.data_emissao_rg" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_emissao_rg', 10)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Orgão Emissor" prop="orgao_emissor_rg" key="orgao_emissor_rg">
                                <el-input v-model="dados.orgao_emissor_rg" maxlength="191" v-on:blur="formatData('orgao_emissor_rg')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="UF RG" prop="uf_rg" key="uf_rg">
                                <el-input v-model="dados.uf_rg" maxlength="191" v-on:blur="formatData('uf_rg')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="(dados.modelo_registro === 0 || dados.modelo_registro === 1) ? 20 : 24" :md="(dados.modelo_registro === 0 || dados.modelo_registro === 1) ? 20 : 24">
                            <el-form-item label="Modelo do Registro" prop="modelo_registro" key="modelo_registro">
                                <el-select @change="changeModeloRegistro()" v-model="dados.modelo_registro" clearable>
                                    <el-option key="" label="" value=""></el-option>
                                    <el-option :key="0" label="ANTIGO" :value="0"></el-option>
                                    <el-option :key="1" label="NOVO" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4" v-if="dados.modelo_registro === 0 || dados.modelo_registro === 1">
                            <el-form-item label="Data de Emissão" prop="data_emissao_registro" key="data_emissao_registro">
                                <el-input v-model="dados.data_emissao_registro" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_emissao_registro', 10)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="dados.modelo_registro === 0">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="16" :md="16">
                                <el-form-item label="Registro" prop="reg_nasc_antigo_registro" :rules="[$requiredBlur]" key="reg_nasc_antigo_registro">
                                    <el-input v-model="dados.reg_nasc_antigo_registro" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_registro')" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Folha" prop="reg_nasc_antigo_folha" :rules="[$requiredBlur]" key="reg_nasc_antigo_folha">
                                    <el-input v-model="dados.reg_nasc_antigo_folha" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_folha')" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Livro" prop="reg_nasc_antigo_livro" :rules="[$requiredBlur]" key="reg_nasc_antigo_livro">
                                    <el-input v-model="dados.reg_nasc_antigo_livro" maxlength="191" v-on:blur="formatData('reg_nasc_antigo_livro')" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cartório" :rules="[$requiredBlur]" prop="cartorio.nome">
                                    <el-input readonly style="width: calc(100% - 55px); float: left" v-model="dados.cartorio.nome" maxlength="191" class="readonly" clearable></el-input>
                                    <el-button style="float: right; width: 40px; height: 40px;" @click="showSearchCartorio" icon="el-icon-search" circle></el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" v-if="dados.cartorio.cidade">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cidade do Cartório" prop="cartorio_id">
                                    <el-input readonly v-model="dados.cartorio.cidade.nome" maxlength="191" class="readonly" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-if="dados.modelo_registro === 1">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Número (com 32 dígitos)" prop="registro_nasc_novo" :rules="[$requiredBlur, $registroBlur]" key="registro_nasc_novo">
                                    <el-input v-model="dados.registro_nasc_novo" maxlength="191" v-mask="'######.##.##.####.#.#####.###.#######-##'" v-on:blur="formatData('registro_nasc_novo', 40)" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                </c-panel>

                <c-panel title="DADOS MÉDICOS E SOCIAIS" titleIcon='fas fa-briefcase-medical'>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Recebe Bolsa Família? *" prop="recebe_bolsa_familia" :rules="[$requiredChange]" key="recebe_bolsa_familia">
                                <el-select v-model="dados.recebe_bolsa_familia" clearable>
                                    <el-option :key="true" label="SIM" :value="true"></el-option>
                                    <el-option :key="false" label="NÃO" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Possui Internet na Residência?" prop="possui_internet" key="possui_internet">
                                <el-select v-model="dados.possui_internet" clearable>
                                    <el-option :key="true" label="SIM" :value="true"></el-option>
                                    <el-option :key="false" label="NÃO" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Possui Computador na Residência?" prop="possui_computador" key="possui_computador">
                                <el-select v-model="dados.possui_computador" clearable>
                                    <el-option :key="true" label="SIM" :value="true"></el-option>
                                    <el-option :key="false" label="NÃO" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Qtd. Smartphones na Residência" key="qtd_smartphones">
                                <el-input v-model="dados.qtd_smartphones" maxlength="191" clearable></el-input>
                            </el-form-item>
                        </el-col>                        
                    </el-row>


                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Alergias" prop="alergias" key="alergias">
                                <el-select v-model="dados.alergias" multiple clearable>
                                    <el-option
                                        v-for="(item, i) in alergias"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Doenças" prop="doencas" key="doencas">
                                <el-select v-model="dados.doencas" multiple clearable>
                                    <el-option
                                        v-for="(item, i) in doencas"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>                    
                    <el-row :gutter="10" v-for="(item, i) in dados.deficiencias" :key="i">
                        <el-col :xs="24" :sm="17" :md="17">
                            <el-form-item label="Deficiência" prop="deficiencias" key="deficiencias">
                                <el-select v-model="dados.deficiencias[i].deficiencia_id" clearable>
                                    <el-option
                                        style="text-transform: uppercase;"
                                        v-for="(item, i) in deficiencias"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="CID-10" prop="cid10" key="cid10">                               
                                <el-input v-model="dados.deficiencias[i].cid10" maxlength="191" clearable></el-input>                               
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :xs="24" :sm="4" :md="4">
                            <el-upload
                                :key="dados.deficiencias[i].deficiencia_id"
                                style="display: inline-block; display: flex; margin-top: 16px; border-bottom: 1px solid #989898"
                                :action="`${$store.state.config.baseUrlApi}/api/file/upload-file/${i}`"
                                :on-change="handleChange"
                                :file-list="dados.deficiencias[i].arquivosCid10">
                                <el-button size="small" type="primary" style="margin-bottom: 4px;">
                                    <i class="fas fa-file"></i>
                                </el-button>
                            </el-upload>
                        </el-col> -->
                        <el-col :xs="24" :sm="1" :md="1">
                            <el-button v-if="i != (dados.deficiencias && dados.deficiencias.length - 1)" @click="removerDeficiencia(i)" type="danger" icon="el-icon-delete" style="margin-top: 21px;"></el-button>

                            <el-button v-if="i == (dados.deficiencias && dados.deficiencias.length - 1)" @click="adicionarDeficiencia()" type="primary" style="margin-top: 21px;">
                                <i class="fas fa-plus"></i>
                            </el-button>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="dados.deficiencias && dados.deficiencias.length > 0 && dados.deficiencias[0].deficiencia_id">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Recursos para uso do(a) aluno(a) e para a participação em avaliações do Inep (Saeb):" prop="recursosProvas" key="recursosProvas">
                                <el-select v-model="dados.recursosProvas" multiple clearable>
                                    <el-option
                                        style="text-transform: uppercase;"
                                        v-for="(item, i) in recursosProvas"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    
                </c-panel>

                <c-panel title="ENDEREÇAMENTO" titleIcon='fas fa-map-marker-alt'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="CEP *" prop="cep" :rules="[$requiredBlur]" key="cep">
                                <el-input v-model="dados.cep" maxlength="191" v-mask="'#####-###'" v-on:blur="getEnderecoByCep()" class="input-with-select icon-input" clearable>
                                    <el-button @click="showSearchEndereco" slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="16" :md="16">
                            <el-form-item label="Logradouro *" prop="logradouro" :rules="[$requiredBlur]" key="logradouro">
                                <el-input v-model="dados.logradouro" maxlength="191" v-on:blur="formatData('logradouro')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Número *" prop="numero" :rules="[$requiredBlur]" key="numero">
                                <el-input v-model="dados.numero" maxlength="191" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Bairro" prop="bairro" :rules="[$requiredBlur]" key="bairro">
                                <el-input readonly v-model="dados.bairro" maxlength="191" class="readonly" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Complemento" prop="complemento">
                                <el-input v-model="dados.complemento" maxlength="191" v-on:blur="formatData('complemento')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Zona *" prop="localizacao_zona" :rules="[$requiredChange]" key="localizacao_zona">
                                <el-select v-model="dados.localizacao_zona" clearable>
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Localização Diferenciada*" prop="localizacao_diferenciada" :rules="[$requiredChange]" key="localizacao_diferenciada">
                                <el-select v-model="dados.localizacao_diferenciada" clearable>
                                    <el-option :key="1" label="ÁREA DE ASSENTAMENTO" :value="1"></el-option>
                                    <el-option :key="2" label="TERRA INDÍGENA" :value="2"></el-option>
                                    <el-option :key="3" label="REMANESCENTE QUILOMBOS" :value="3"></el-option>
                                    <el-option :key="7" label="NÃO ESTÁ EM LOCALIZAÇÃO DIFERENCIADA" :value="7"></el-option>
                                    <el-option :key="8" label="ÁREA ONDE SE LOCALIZA POVOS E COMUNIDADES TRADICIONAIS" :value="8"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Cidade *" :rules="[$requiredBlur]" prop="cidade.nome">
                                <el-input readonly v-model="dados.cidade.nome" maxlength="191" class="readonly" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div v-if="input_autorizacao">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Código de Autorização" prop="autorizacao_smed" key="autorizacao_smed">
                                    <el-input v-model="dados.autorizacao_smed" maxlength="191" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-alert title="Você poderá informar um código de autorização gerado pela Instituição para continuar." type="warning"></el-alert>
                    </div>
                </c-panel>
                <c-panel title="OBSERVAÇÃO" titleIcon='fas fa-clipboard-list'>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="observacao.aluno">
                                <el-input type="textarea" autosize v-model="dados.observacao" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <el-row :gutter="10">
                    <div class="u-text-right u-mt-20">
                        <el-button type="primary" id="btn-aluno" native-type="submit">{{ (call == 'index') ? 'SALVAR' : 'PROXIMO >' }}</el-button>
                    </div>
                </el-row>

            </div>
        </el-form>

        <search-cartorio key="searchCartorio" v-on:close="searchCartorio = false" :open="searchCartorio" v-on:emitCartorio="emitCartorio"></search-cartorio>
        <search-cidade key="searchCidade" v-on:close="searchCidade = false" :open="searchCidade" v-on:emitCidade="emitMunNascimento"></search-cidade>
        <search-endereco key="searchEndereco" v-on:close="searchEndereco = false" :open="searchEndereco" v-on:emitEndereco="emitEndereco"></search-endereco>

        <el-dialog :close-on-click-modal="false" title="CADASTROS SIMILARES" width="90%" :visible.sync="dialogCadastrosSimilares">
            <div v-if="dialogCadastrosSimilares" style="margin-top: 20px;">

                <i style="margin-bottom: 20px; display: block;">
                    Existe cadastro similar ao cadastro de {{ dados.nome }} no sistema.
                    É possível que este (a) aluno (a) já possua cadastro no sistema conforme apresentado na tabela abaixo.<br>
                    Você poderá realizar a matrícula a partir da (s) opção (ões) a seguir ou fechar esta tela e continuar o cadastro de {{ dados.nome }}.
                </i>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 70px;">cod</th>
                                <th>Nome</th>
                                <th>Data Nasicmento</th>
                                <th>Mãe</th>
                                <th>Instituição</th>
                                <th style="width: 170px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in cadastrosSimilares" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.nome }}</td>
                                <td>{{ $moment(item.data_nascimento).format('DD/MM/YYYY') }}</td>
                                <td>{{ item.mae }}</td>
                                <td>{{ (item.matriculas.length > 0) ? item.matriculas[0].instituicao.apelido : '-' }}</td>
                                <td class="u-text-center acao">

                                    <span style="color: #ff0000;" v-if="item.matriculas.length > 0">
                                        MATRICULADO (A)
                                    </span>

                                    <a v-if="item.matriculas.length == 0" @click="openMatriculaSimilar(item.id)" href="javascript:void(0)">
                                        REALIZAR MATRÍCULA
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="u-text-right u-mt-20">
                    <el-button class="close-button" @click="dialogCadastrosSimilares = false">FECHAR</el-button>
                </div>
            </div>
        </el-dialog>


    </div>
</template>
<script>

import Vue from 'vue'

import searchCartorio from "@/components/search/search-cartorio"
import searchCidade from "@/components/search/search-cidade"
import searchEndereco from "@/components/search/search-endereco"

export default {
    props: ['paramId', 'call'],
    data: () => ({
        input_autorizacao: false,
        dialogCadastrosSimilares: false,
        cadastrosSimilares: [],
        searchCartorio: false,
        searchCidade: false,
        searchEndereco: false,
        editAluno: false,
        alert: false,
        alergias: [],
        doencas: [],
        deficiencias: [],
        recursosProvas: [],
        paises: [],
        dados: {
            
            recursosProvas: [],
            possui_internet: '',
            possui_computador: '',
            qtd_smartphones: '',
            autorizacao_smed: '',
            alergias: [],
            doencas: [],
            deficiencias: [],
            id: '',
            cpf: '',
            rg: '',
            data_emissao_rg: '',
            orgao_emissor_rg: '',
            uf_rg: '',
            nome: '',
            inep: '',
            nome_aluno_censo: '',
            data_nascimento: '',
            pai: '',
            mae: '',
            responsavel: '',
            parentesco: '',
            sexo: '',
            cor: '',
            nacionalidade: '',
            cartao_sus: '',
            nis: '',
            modelo_registro: '',
            tipo_registro: '',
            registro_nasc_novo: '',
            reg_nasc_antigo_registro: '',
            reg_nasc_antigo_folha: '',
            reg_nasc_antigo_livro: '',
            data_emissao_registro: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cep: '',
            complemento: '',
            localizacao_zona: '',
            localizacao_diferenciada: '',
            telefone: '',
            celular: '',
            celular_outro: '',
            recebe_bolsa_familia: '',
            observacao: '',
            situacao: '',
            pais_id: '',
            municipio_nascimento_id: '',
            cartorio_id: '',
            cidade_id: '',
            cidade: {
                id: '',
                nome: '',
                estado: {
                    id: '',
                    nome: ''
                }
            },
            pais: {
                id: '',
                nome: ''
            },
            municipio_nascimento: {
                id: '',
                nome: ''
            },
            cartorio: {
                id: '',
                nome: '',
                cidade: {
                    id: '',
                    nome: ''
                }
            }
        }

    }),
    mounted(){

        this.initFormAluno();
    },
    methods:{
        handleChange(event){

            if(event && event.response){

                Vue.set(this.dados.deficiencias[event.response['i']].arquivosCid10, 0, {
                    name: event.response['name'],
                    url: event.response['url']
                });
            }
        },
        adicionarDeficiencia(){
            this.dados.deficiencias.push({
                deficiencia_id: '',
                cid10: '',
                nome: ''
                // arquivosCid10: []
            });
        },
        removerDeficiencia(i){
            this.dados.deficiencias.splice(i, 1);
        },
        openMatriculaSimilar(id){

            this.dialogCadastrosSimilares = false;
            this.getAlunoById(id);
            this.editAluno = true;
        },
        async checkIfAlunoExistByDocumento(){

            let documento = '';

            if(this.dados.cpf) {
                documento = this.dados.cpf;
            }

            if(this.dados.registro_nasc_novo) {
                documento = this.dados.registro_nasc_novo;
            }

            if(!documento){
                return;
            }

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/checkIfAlunoExistByDocumento`, { documento }, this.$store.getters.getHeaderAuth);

            if(response.data.id){

                const queryParams = this.$route.query;

                this.$router.push({ path: `/admin/matricula/passo-a-passo/${response.data.id}`, query: queryParams }).catch(() => {})

            } else {

                this.checkIfAlunoExist();                
            }

        },
        checkIfAlunoExist(){

            if(this.dados.nome){
                this.formatData('nome');
            }

            if(this.dados.data_nascimento){
                this.formatData('data_nascimento', 10);
            }

            if(this.editAluno){
                return false;
            }

            if(this.dados.nome && this.dados.data_nascimento){

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/checkIfAlunoExist`, {nome: this.dados.nome, data_nascimento: this.dados.data_nascimento}, this.$store.getters.getHeaderAuth).then(response => {

                    if(response.data.length > 0){

                        this.cadastrosSimilares = response.data;
                        this.dialogCadastrosSimilares = true;
                    }

                }).catch((error) => { this.$store.commit('throwException', error); });
            }

        },
        initFormAluno(){
        //INICIA FORMULÁRIO DE ALUNO

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/initFormAluno`, this.$store.getters.getHeaderAuth).then(response => {

                this.alergias = response.data.alergias;
                this.doencas = response.data.doencas;
                this.deficiencias = response.data.deficiencias;
                this.paises = response.data.paises;
                this.recursosProvas = response.data.recursosProvas;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getAlunoById(id){
        //BUSCA ALUNO PARA SER EDITADO

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.data_nascimento)
                    response.data.data_nascimento = this.$moment(response.data.data_nascimento).format('DD/MM/YYYY');

                if(response.data.data_emissao_rg)
                    response.data.data_emissao_rg = this.$moment(response.data.data_emissao_rg).format('DD/MM/YYYY');

                if(response.data.data_emissao_registro)
                    response.data.data_emissao_registro = this.$moment(response.data.data_emissao_registro).format('DD/MM/YYYY');

                this.dados = JSON.parse(JSON.stringify(response.data));

                if(this.dados.deficiencias && this.dados.deficiencias.length == 0){
                    this.dados.deficiencias.push({
                        deficiencia_id: '',
                        cid10: '',
                        nome: ''
                        // arquivosCid10: []
                    });
                }

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showSearchCartorio(){
        //ABRE MODAL DE BUSCA DE CARTÓRIO

            this.searchCartorio = true;
        },
        showSearchMunNascimento(){
        //ABRE MODAL DE BUSCA DE MUNC. NASCIMENTO

            this.searchCidade = true;
        },
        showSearchEndereco(){
        //ABRE MODAL DE BUSCA DE ENDEREÇO

            this.searchEndereco = true;
        },
        emitCartorio(cartorio){
        //QUANDO UM CARTÓRIO É SELECIONADO

            this.searchCartorio = false;
            this.dados.cartorio = cartorio;
            this.dados.cartorio_id = cartorio.id;
        },
        emitMunNascimento(municipio_nascimento){
        //QUANDO UM MUNC. NASCIMENTO É SELECIONADO

            this.searchCidade = false;
            this.dados.municipio_nascimento = municipio_nascimento;
            this.dados.municipio_nascimento_id = municipio_nascimento.id;
        },
        emitEndereco(endereco){
        //QUANDO UM ENDEREÇO É SELECIONADO

            this.searchEndereco = false;
            this.dados.cep = endereco.cep;
            this.dados.logradouro = endereco.logradouro.nome;
            this.dados.bairro = endereco.bairro.nome;
            this.dados.cidade = endereco.cidade;
            this.dados.cidade_id = endereco.cidade.id;
        },
        getEnderecoByCep(){
        //CHAMADO QUANDO O INPUT DE CEP PERDE O FOCO

            if(this.dados.cep.length < 9){

                this.dados.cep = '';
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/cep/getEnderecoByCep/` + this.dados.cep.replace(/\-/g,''), this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.length == 0){

                    this.dados.cep = '';
                    this.dados.logradouro = '';
                    this.dados.bairro = '';
                    this.dados.cidade.nome = '';
                    this.dados.cidade.id = '';
                    this.dados.cidade_id = '';
                    this.dados.estado = '';
                    window.eventBus.$emit('alert', {msg: 'Atenção! Cep inválido.', type: 'warning'});
                    return false;
                }

                this.dados.logradouro = (response.data.logradouro) ? response.data.logradouro.nome : '';
                this.dados.bairro = (response.data.bairro) ? response.data.bairro.nome : '';
                this.dados.cidade.nome = (response.data.cidade) ? response.data.cidade.nome : '';
                this.dados.cidade.id = (response.data.cidade) ? response.data.cidade.id : '';
                this.dados.cidade_id = (response.data.cidade) ? response.data.cidade.id : '';
                this.dados.estado = (response.data.cidade) ? response.data.cidade.estado.nome : '';

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitAluno(){
        //CHAMADO NO SUBMIMT DO FORMULÁRIO DE ALUNO

            document.getElementById("btn-aluno").focus();

            this.$refs.dados.validate( async (valid) => { if(valid){

                try{

                    let deficiencias = [];
                    for(let i in this.dados.deficiencias){
                        if(this.dados.deficiencias[i].deficiencia_id){
                            deficiencias.push(this.dados.deficiencias[i]);
                        }else if(!this.dados.deficiencias[i].deficiencia_id && this.dados.deficiencias[i].cid10){
                            this.$alert('Você informou a cid e não informou a deficiência.', 'Atenção', { confirmButtonText: 'OK' });
                            return;
                        }
                    }
                    if(deficiencias.length > 0){
                        for(let i in deficiencias){
                            for(let j in this.deficiencias){

                                if(deficiencias[i].deficiencia_id == this.deficiencias[j].id){
                                    deficiencias[i].nome = this.deficiencias[j].nome;
                                }
                            }
                        }
                    }
                    this.dados.deficiencias = deficiencias.length > 0 ? deficiencias : null; 

                    let res;
                    window.eventBus.$emit('loading', true);

                    if(this.editAluno){

                        res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth);

                    }else{

                        res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/store`, this.dados, this.$store.getters.getHeaderAuth);
                        Vue.set(this.dados, 'id', res.data.id);
                    }

                    window.eventBus.$emit('loading', false);

                    if(typeof res.data.throw !== 'undefined'){

                        if(this.dados.autorizacao_smed){

                            this.$alert('O código de autorização informado não é válido.', 'Atenção', { confirmButtonText: 'OK' });

                        }else{

                            window.eventBus.$emit('throw', res.data.throw);
                            this.input_autorizacao = true;
                        }

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitFormAluno', this.dados);
                    }

                }catch(e){ window.eventBus.$emit('loading', false); this.$store.commit('throwException', e); console.log(e); }

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});
        },
        changeModeloRegistro(){
        //QUAND O SELECT DE MODELO DE REGISTRO É ALTERADO

            this.dados.registro_nasc_novo = '';
            this.dados.reg_nasc_antigo_registro = '';
            this.dados.reg_nasc_antigo_folha = '';
            this.dados.reg_nasc_antigo_livro = '';
            this.dados.data_emissao_registro = '';
            this.dados.cartorio_id = '';
            this.dados.cartorio = { id: '', nome: '', cidade: { id: '', nome: '' }};
        },
        changeNacionalidade(){
        //QUANDO O SELECT DE NACIONALIDADE É ALTERADO

            if(this.dados.nacionalidade == 1){

                this.dados.pais_id = 1;

                setTimeout(()=>{

                    this.showSearchMunNascimento();

                }, 500);

            }else if(this.dados.nacionalidade == 2){

                this.dados.pais_id = 1;

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento = { id: '', nome: '' };

            }else if(this.dados.nacionalidade == 3){

                this.dados.pais_id = '';
                this.dados.pais.id = '';
                this.dados.pais.nome = '';

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento.id = '';
                this.dados.municipio_nascimento.nome = '';
            }

        },
        formatData(field, size = null){
        //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        },
        resetForm(){

            this.dados = {
                alergias: [],
                doencas: [],
                deficiencias: [{
                    deficiencia_id: '',
                    cid10: '',
                    nome: ''
                    // arquivosCid10: []
                }],
                id: '',
                cpf: '',
                rg: '',
                data_emissao_rg: '',
                orgao_emissor_rg: '',
                uf_rg: '',
                nome: '',
                inep: '',
                nome_aluno_censo: '',
                data_nascimento: '',
                pai: '',
                mae: '',
                responsavel: '',
                parentesco: '',
                sexo: '',
                cor: '',
                nacionalidade: '',
                cartao_sus: '',
                nis: '',
                modelo_registro: '',
                tipo_registro: '',
                registro_nasc_novo: '',
                reg_nasc_antigo_registro: '',
                reg_nasc_antigo_folha: '',
                reg_nasc_antigo_livro: '',
                data_emissao_registro: '',
                logradouro: '',
                numero: '',
                bairro: '',
                cep: '',
                complemento: '',
                localizacao_zona: '',
                telefone: '',
                celular: '',
                celular_outro: '',
                recebe_bolsa_familia: '',
                observacao: '',
                situacao: '',
                pais_id: '',
                municipio_nascimento_id: '',
                cartorio_id: '',
                cidade_id: '',
                cidade: {
                    id: '',
                    nome: '',
                    estado: {
                        id: '',
                        nome: ''
                    }
                },
                pais: {
                    id: '',
                    nome: ''
                },
                municipio_nascimento: {
                    id: '',
                    nome: ''
                },
                cartorio: {
                    id: '',
                    nome: '',
                    cidade: {
                        id: '',
                        nome: ''
                    }
                }
            };
        }
    },
    components:{ searchCartorio, searchCidade, searchEndereco },
    watch: {
        '$route.params.id'(value) {
            
            this.getAlunoById(value);
            this.editAluno = true;
        },
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAlunoById(value);
                    this.editAluno = true;

                }else{
                    
                    this.resetForm();

                    if(Object.keys(this.$route.query).length !== 0){

                        this.dados.nome = this.$route.query.nome;
                        this.dados.data_nascimento = this.$moment(this.$route.query.data_nascimento).format('DD/MM/YYYY');
                        this.dados.responsavel = this.$route.query.responsavel;

                        this.dados.cpf = this.$route.query.cpf;
                        this.dados.celular = this.$route.query.celular;

                        if(this.$route.query.registro_nasc) {
                            this.dados.modelo_registro = 1;
                            this.dados.registro_nasc_novo = this.$route.query.registro_nasc;
                        }

                        this.checkIfAlunoExistByDocumento();

                    }else {

                        this.editAluno = false;
                    }
                }
            }
        }
    }
}
</script>
<style>
    .el-upload-list__item:first-child {
        margin-top: 5px !important;
    }
</style>